import { getUser, getSubteam, getProject, getTask, getMilestone, getTaskGroup } from '../services/store-service';

import { fetchUser } from '../actions/users';
import { fetchProject } from '../actions/projects';
import { fetchSubteam } from '../actions/subteams';
import { fetchTask } from '../actions/tasks';
import { fetchMilestone } from '../actions/milestones';
import { fetchTaskGroup } from '../actions/task-groups';

const HYDRATORS = {
    user: {
        get: getUser,
        resolve: fetchUser
    },
    subteam: {
        get: getSubteam,
        resolve: fetchSubteam
    },
    project: {
        get: getProject,
        resolve: fetchProject
    },
    task: {
        get: getTask,
        resolve: fetchTask
    },
    milestone: {
        get: getMilestone,
        resolve: fetchMilestone
    },
    taskGroup: {
        get: getTaskGroup,
        resolve: fetchTaskGroup
    }
}

// Example:
// const objToHydrate = {
//     id: 1,
//     name: 'Name',
//     task: 'hydrate(task, 1)'
// }
// 
// hydrate(objToHydrate);

export const hydrate = input => {
    const promises = [];

    const resolved = Object.keys(input)
        .reduce((result, current) => {
            if (input[current] && typeof input[current] === 'string') {
                const hydratorArgs = input[current].match(/^hydrate\((.+?)\)$/);

                if (hydratorArgs && hydratorArgs[1]) {
                    const [type, id, prop] = hydratorArgs[1].replace(/,\s/g, ',').split(',');
                    const hydrated = hydrateSingle(type, id);

                    if (hydrated instanceof Promise) {
                        promises.push(hydrated);
                    } else {
                        const hydratedValue = prop ? hydrated[prop] : hydrated;
                        return {
                            ...result,
                            [current]: hydratedValue
                        }
                    }
                }
            }

            return {
                ...result,
                [current]: input[current]
            }
        }, {});

    return Promise.all(promises)
        .then(() => {
            if (promises.length) {
                return hydrate(input);
            }

            return resolved;
        });
}

export const hydrateArray = (type, array, sync) => {
    const result = array.map(id => hydrateSingle(type, id, sync));

    if (sync) {
        return result;
    };

    return Promise.all(result);
}

const hydrateSingle = (type, id, sync) => {
    const hydrator = HYDRATORS[type];

    if (!hydrator) {
        console.error(`No hydrator for type: ${type}`);

        return id;
    }

    const resolved = HYDRATORS[type].get(id);

    if (resolved) {
        return resolved;
    }

    if (sync) {
        return id;
    }

    return HYDRATORS[type].resolve(id);
}
